import { RefContextLanguage } from '../providers/LanguageProvider';
import * as libCon from '../community-hats-js-library/Constants';
import * as locCon from '../LocalConstants';
import Header from '../components/Header';
import CustomText from '../elements/CustomText';
import CustomButton from '../elements/CustomButton';
import { setMultipleValues, setStoredValue } from '../hooks/StoreHooks';
import CheckboxGroup from '../elements/CheckboxGroup';
import { SyncATOButton } from '../elements/SyncATOButton';
import CompletionStatusText from '../elements/CompletionStatusText';
import { SimpleStoreCopyFieldFromATO } from '../elements/SimpleStoreCopyField';
import { showNotification } from '../utils/generalFunctions';
import { trim } from '../community-hats-js-library/utils/generalFunctions';

function ToolCorrectPhoneSerial() {
  const i18n = RefContextLanguage();

  // Local checkboxes
  const allCheckboxes = [locCon.CPS_UPDATE_BUNDLE, locCon.CPS_UPDATE_PLACEMENT, locCon.CPS_CORRECT_LOCATION_TRACKER];

  const restartProcess = () => {
    let checkBoxValues = {};

    allCheckboxes.forEach((k) => (checkBoxValues[k] = false));

    setMultipleValues(checkBoxValues);

    showNotification(i18n.t('processRestarted'));
  };

  return (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <Header long={false} />
        <CustomText type={locCon.MODULE_TITLE_TEXT}>{i18n.t('ToolCorrectPhoneSerial')}</CustomText>
        <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('stepsToToolCorrectPhoneSerial')}</CustomText>

        <CustomButton type={locCon.PRIMARY_BUTTON} onClick={() => restartProcess()}>
          {i18n.t('restartProcess')}
        </CustomButton>

        <div className="horizontalLine" />

        <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{i18n.t('phoneSerial')}</CustomText>
        <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('enterCorrectPhoneSerial')}</CustomText>

        <SimpleStoreCopyFieldFromATO
          atoId={locCon.AT_OBJECT_PHONE}
          fieldId={libCon.ATF_SERIAL}
          placeHolder={i18n.t('serialNumber')}
          cleanBeforeSavingFunction={trim}
        />

        <SyncATOButton
          atoId={locCon.AT_OBJECT_PHONE}
          atoBehavior={libCon.ATO_BEHAVIOR_PULL}
          onClickCleanup={(val) => setStoredValue(locCon.APPD_LINK_PHONE_SERIAL, val)}
        />

        <div className="horizontalLine" />
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('bundle')}</CustomText>
        <CheckboxGroup
          disableClick={true}
          mainCheckbox={{
            [libCon.ID]: locCon.CPS_UPDATE_BUNDLE,
            [libCon.TEXT]: i18n.t('addUpdateBundleToDataBase'),
            [libCon.CONTAINER]: (
              <SyncATOButton
                atoId={locCon.AT_OBJECT_BUNDLE}
                atoBehavior={libCon.ATO_BEHAVIOR_UPDATE_CREATE}
                onClickCleanup={(val) => setStoredValue(locCon.CPS_UPDATE_BUNDLE, val)}
              />
            ),
          }}
        />

        <div className="horizontalLine" />
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('phonePlacementToDataBaseTitle')}</CustomText>
        <CheckboxGroup
          disableClick={true}
          mainCheckbox={{
            [libCon.ID]: locCon.CPS_UPDATE_PLACEMENT,
            [libCon.TEXT]: i18n.t('phonePlacementToDataBase'),
            [libCon.CONTAINER]: (
              <SyncATOButton
                atoId={locCon.AT_OBJECT_PHONE_PLACEMENT}
                atoBehavior={libCon.ATO_BEHAVIOR_UPDATE}
                onClickCleanup={(val) => setStoredValue(locCon.CPS_UPDATE_PLACEMENT, val)}
              />
            ),
          }}
        />

        <div className="horizontalLine" />

        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('locationTracker')}</CustomText>
        <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('checkLocationTrackerInstructions')}</CustomText>
        <CheckboxGroup
          mainCheckbox={{
            [libCon.ID]: locCon.CPS_CORRECT_LOCATION_TRACKER,
            [libCon.TEXT]: i18n.t('checkLocationTracker'),
          }}
        />

        <div className="horizontalLine" />

        <CompletionStatusText checkBoxIds={allCheckboxes} />

        <div className="horizontalLine" />
      </div>
    </div>
  );
}

export default ToolCorrectPhoneSerial;
